module.exports = __webpack_public_path__ + "monteirolobato.jpg?7ba7952c69eea68a00d562182c9e0787";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/projetos/monteirolobato.jpg
// module id = 138
// module chunks = 0